module.exports = __webpack_public_path__ + "static/5-dae567031a0428fde39e005aededf77a.png";